import React from 'react';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { WpIcon } from 'Wpds/components/icon';
import ProductiveRelationshipSteps from './ProductiveRelationshipSteps';
import { WpText } from 'Wpds/components/text';

// Hooks
import { useRelationshipGuide } from 'Shared/utils/hooks/use-relationship-guide';

// Styles
import './RelationshipGuideInsights.scss';

type Props = {
  selfSurveyUserId: string;
  colleagueSurveyUserId?: string;
};

const RelationshipGuideInsights = ({ selfSurveyUserId, colleagueSurveyUserId }: Props): JSX.Element => {
  const baseClassName = 'RelationshipGuideInsights';
  const { loading, relationship, strengths, cautions, tips } = useRelationshipGuide({
    person1: selfSurveyUserId,
    person2: colleagueSurveyUserId,
  });

  if (loading || !relationship) return null;

  return (
    <div className={baseClassName}>
      <WpText
        tag="p"
        variant="bodyXl"
        bold
      >{`${relationship.person2DisplayName} & ${relationship.person1DisplayName}'s Relationship`}</WpText>
      <WpContainer>
        <WpContainerBody>
          <p>
            Every relationship has its Strengths and Caution Areas. Having these guidelines and tips can help better
            prepare both parties to work together and communicate smoothly.
          </p>
          <div className={`${baseClassName}__strengths`}>
            <div className={`${baseClassName}__strengths__item`}>
              <WpText tag="p" variant="bodyMd" bold>
                Relationship Strengths:
              </WpText>
              <ul className={`${baseClassName}__strengths__item__styled-list`}>
                {strengths.map((item, index) => (
                  <li key={`tips_${index}`}>
                    <WpText tag="span" variant="bodySm">
                      {item}
                    </WpText>
                  </li>
                ))}
              </ul>
            </div>
            <div className={`${baseClassName}__cautions__item ${baseClassName}__cautions--left`}>
              <WpText tag="p" variant="bodyMd" bold>
                Relationship Cautions:
              </WpText>
              <ul className={`${baseClassName}__cautions__item__styled-list`}>
                {cautions.map((item, index) => (
                  <li key={`tips_${index}`}>
                    <WpText tag="span" variant="bodySm">
                      {item}
                    </WpText>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className={`${baseClassName}__tips`}>
            <div className={`${baseClassName}__tips__title`}>
              <span className={`${baseClassName}__tips__title__circle-relationship`}>
                <WpIcon name="comments" size="md" />
              </span>
              <WpText tag="p" variant="bodyMd" bold>
                Relationship Tips:
              </WpText>
            </div>
            <ul className={`${baseClassName}__tips__styled-list`}>
              {tips.map((item, index) => (
                <li key={`tips_${index}`}>{item}</li>
              ))}
            </ul>
          </div>
        </WpContainerBody>
      </WpContainer>
      <ProductiveRelationshipSteps />
    </div>
  );
};

export default RelationshipGuideInsights;
